
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useNotifications } from '../../context/NotificationContext';
import { useAuth } from '../../context/AuthContext';
import { BellFill, BoxArrowRight, PersonCircle, QuestionCircleFill } from 'react-bootstrap-icons';
import SwitchViewButton from './SwitchViewButton';

const formatRelativeTime = (createdAt) => {
  const now = new Date();
  const created = new Date(createdAt);
  const diffMs = now - created;
  const diffMinutes = Math.floor(diffMs / 60000);
  if (diffMinutes < 1) return 'hace un momento';
  if (diffMinutes < 60) return `hace ${diffMinutes} minuto${diffMinutes !== 1 ? 's' : ''}`;
  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `hace ${diffHours} hora${diffHours !== 1 ? 's' : ''}`;
  const diffDays = Math.floor(diffHours / 24);
  return `hace ${diffDays} día${diffDays !== 1 ? 's' : ''}`;
};

const NavigationBar = () => {
  const { notifications, unreadCount, markAsRead, markAllAsRead, openEntity } = useNotifications();
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const handleNotificationToggle = () => {
    setShowNotifications(!showNotifications);
  };

  const handleNotificationClick = (n) => {
    markAsRead(n.notification_id);
    if (n.entity_type && n.entity_id) {
      openEntity(n.entity_type, n.entity_id);
    }
    setShowNotifications(false);
  };

  const isActive = (path) => {
    if (path === '/admin') {
      return location.pathname.startsWith('/admin');
    }
    return location.pathname === path;
  };

  const SOPORTE_ROUTES = {
    teacher: '/docente/soporte',
    utp: '/utp/soporte',
    admin: '/admin/soporte',
  };
  const soporteRoute = user?.user_type ? SOPORTE_ROUTES[user.user_type] : null;

  return (
    <header className="artemis-header">
      <div className="artemis-navbar">
        <Link to="/" className="artemis-brand">
          <div className="artemis-brand-icon">
            <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
              <path d="M18 4L4 28h28L18 4z" fill="white" fillOpacity={0.9}/>
              <path d="M18 12l-6 12h12l-6-12z" fill="white" fillOpacity={0.45}/>
            </svg>
          </div>
          Sistema Artemis
        </Link>

        {user?.organization_name && user.user_type !== 'master' && (
          <div className="artemis-tenant-name" title={user.organization_name}>
            {user.organization_name}
          </div>
        )}

        <nav className="artemis-nav">

          {soporteRoute && (
            <button
              className="artemis-soporte-btn"
              onClick={() => navigate(soporteRoute)}
              title="Centro de Soporte"
            >
              <QuestionCircleFill size={18} />
              <span>Soporte</span>
            </button>
          )}

          <SwitchViewButton />

          <div className="artemis-notifications">
            <button
              className="artemis-nav-link artemis-notification-btn"
              onClick={handleNotificationToggle}
            >
              <BellFill size={18} />
              {unreadCount > 0 && (
                <span className="artemis-notification-badge">
                  {unreadCount}
                </span>
              )}
            </button>

            {showNotifications && (
              <div className="artemis-notification-dropdown">
                <div className="artemis-notification-header">
                  <span>Notificaciones</span>
                  {unreadCount > 0 && (
                    <button
                      className="artemis-notification-mark-all"
                      onClick={() => { markAllAsRead(); setShowNotifications(false); }}
                    >
                      Marcar todas como leídas
                    </button>
                  )}
                </div>
                {notifications.length > 0 ? (
                  notifications.map(n => (
                    <div
                      key={n.notification_id}
                      className={`artemis-notification-item ${n.is_read ? 'read' : ''}`}
                      onClick={() => handleNotificationClick(n)}
                      style={{ cursor: n.entity_id ? 'pointer' : 'default' }}
                    >
                      <div className="artemis-notification-title">{n.title}</div>
                      <div className="artemis-notification-time">
                        {formatRelativeTime(n.created_at)}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="artemis-notification-item text-muted">
                    No hay notificaciones
                  </div>
                )}
              </div>
            )}
          </div>
                    {/* Usuario autenticado */}
          {user && (
            <div className="artemis-nav-user">
              <PersonCircle size={16} />
              <span className="artemis-nav-user-name">{user.full_name}</span>
              <button
                className="artemis-nav-logout"
                onClick={handleLogout}
                title="Cerrar sesión"
              >
                <BoxArrowRight size={16} />
              </button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default NavigationBar;
